import { default as breakpoints } from "./breakpoints";

export const unocss$ = {
  breakpoints,
};
